import type { Campaign } from '../campaignsApi';
import { campaignStatusPresentation, campaignStatusStyle } from '../campaignStatusPresentation';
import './campaign-status-badge.css';

interface Props { campaign?: Campaign; status?: string; label?: string }

export function CampaignStatusBadge({ campaign, status = '', label }: Props) {
  const presentation = campaign ? campaignStatusPresentation(campaign) : campaignStatusStyle(status);
  return <span className="campaign-status-badge" data-tone={presentation.tone}>
    <span className="campaign-status-dot" aria-hidden="true" />{label || presentation.label}
  </span>;
}
